export default "__VITE_ASSET__085101fa__"